import React, { FC, useState } from 'react';
import { CollapsiblePanelControlDefinition } from '../services/layout';
import { FormControlProps } from "../utils";
import { registry } from '../registry';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { TemplatedText } from './TemplatedText';

export interface CollapsiblePanelProps extends FormControlProps<CollapsiblePanelControlDefinition> {}

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    text: function() {
      return {
        padding: '12px',
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary,
        borderRadius: '5px'
      }
    }
  })
});

let currentValues = {};

function CollapsibleChild(props: any) {
  const definition = props.definition;
    const [isOpenObj, setIsOpenObj] = useState<any>(currentValues);
    const classes = useStyles();

    function updateCurrentValues(child: any) {
      currentValues = {...currentValues, ...{[child.id]: !isOpenObj[child.id]}};
      setIsOpenObj(currentValues);
    }

    return (
      <>
        {definition.children?.map((child: any) => (
          <div key={child.id} style={{paddingLeft: '20px', paddingTop: '2px'}}>
            <div onClick={() => updateCurrentValues(child)} className={classes.text} style={{cursor: 'pointer', padding: '10px'}}>
              {
                child.title
                ? <div>{child.title}</div>
                : <TemplatedText template={child.templatedTitle || ''} params={child.titleParams} />
              }
            </div>
            {
              isOpenObj[child.id] && (
                <div style={{padding: child.content ? '10px' : '0', paddingLeft: '10px'}}>
                  {
                    child.content
                    ? <div>{child.content}</div>
                    : <TemplatedText template={child.templatedContent || ''} params={child.contentParams} />
                  }
                </div>
            )}
            {isOpenObj[child.id] && definition.children?.length > 0 && <CollapsibleChild path={props.path} definition={child} />}
          </div>
        ))}
      </>
    );
}

export const CollapsiblePanel: FC<CollapsiblePanelProps> = function(props) {
  const definition = props.definition;
    const [isOpen, setIsOpen] = useState(false);
    const classes = useStyles();

    return (
      <div style={{width: '100%'}}>
        <div onClick={() => setIsOpen(!isOpen)} className={classes.text} style={{cursor: 'pointer'}}>
          {
            definition.title
            ? <div>{definition.title}</div>
            : <TemplatedText template={definition.templatedTitle || ''} params={definition.titleParams} />
          }
        </div>
        <div style={{padding: definition.content ? '10px' : '0', paddingLeft: '10px'}}>
          {isOpen && (
            definition.content
            ? <div>{definition.content}</div>
            : <TemplatedText template={definition.templatedContent || ''} params={definition.contentParams} />
          )}
        </div>
        <div>{isOpen && <CollapsibleChild definition={definition} />}</div>
      </div>
    );
};

registry.registerComponent('CollapsiblePanel', CollapsiblePanel);
